
 <ng-container *ngIf="evalData?.isNewEvaluation">
    <div class="courseDetails whitesmoke insight-course-page" id="courseInsights">
        <div class="container">
            <div class="d-flex align-items-center justify-content-between mb-3 pd-t30">
                <h4 class="text-uppercase font-mob-14 font-16 montserrat-semibold navColor">YOUR PERFORMANCE</h4>
                <a href="javascript:void(0)" class="underline-link font-mob-13 montserrat-semibold primaryColor" (click)="openScoreFaqModal()">{{isV2?'Assessments FAQs':'See how assessments work'}}</a>
            </div>
            <div class="row mg-b40">
                <div *ngFor="let ex of exercises" class="col-12 col-md-6 col-lg-4 mg-b30">
                    <div class="exe-insight-detail">
                        <div class="d-flex navColor justify-content-between mg-b5 mg-x-b20">
                            <p class="darkgray-102 pr-2 font-14">{{ex.title}}</p>
                            <span *ngIf="ex.exerciseResult" class="icon-check-circle font-18 font-mob-16 mediumseagreenColor"></span>
                            <span *ngIf="!ex.exerciseResult" class="icon-info-circle-filled font-18 font-mob-16 crimsonColor"></span>
                        </div>
                        <div class="d-flex navColor justify-content-between align-items-end">

                            <ng-container *ngIf="(currentCourse?.courseTypeVersion == '2' || currentCourse?.courseTypeVersion == '1.1')">
                                <p class="font-16 font-mob-14">{{(ex?.status != 'PUBLISHED' && ex.exerciseResult) ? 'Score Awaited' : (ex?.status == 'PUBLISHED' && ex.exerciseResult) ? 'Your Score':'Not Attempted'}}</p>
                                <h3 *ngIf="ex.exerciseResult && (ex?.status == 'PUBLISHED')" class="font-18 font-mob-16 pl-3 pr-md-4"><strong class="font-30 font-mob-22">{{ex.exerciseResult?.gainedMarks| number:'1.0-0'}}</strong>/{{ex.exerciseResult?.totalMarks | number:'1.0-0'}}
                                </h3>
                            </ng-container>

                            <ng-container *ngIf="(currentCourse?.courseTypeVersion != '2' && currentCourse?.courseTypeVersion != '1.1')">
                                <p class="font-16 font-mob-14">{{ex.exerciseResult?'Your Score':'Not Attempted'}}</p>
                                <h3 *ngIf="ex.exerciseResult" class="font-18 font-mob-16 pl-3 pr-md-4"><strong class="font-30 font-mob-22">{{ex.exerciseResult?.gainedMarks| number:'1.0-0'}}</strong>/{{ex.exerciseResult?.totalMarks | number:'1.0-0'}}
                                </h3>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="progress==100 && behaviourScore?.length">
              <h4 class="text-uppercase font-16 montserrat-semibold navColor mb-3">BEHAVIORAL ANALYSIS
              </h4>
              <div class="completeProgressList p-0 insightTabList mt-0">
                  <div class="pt-md-5 pb-md-5 px-md-5">
                      <div class="position-relative" style="min-height: 480px;">
                          <ul class="nav-leftside nav-leftside--withcircle">
                              <li *ngFor="let score of behaviourScore;index as x" [class.active]="activeTab[x]" (click)="activeBehaviourTab(x)">
                                  <a style="z-index: 1;">
                                      <span class="nav-leftside__subtitle">{{score.title}}</span>
                                  </a>
                                  <div class="container-rightside py-5">

                                    <table class="skill-table mg-b15 mx-auto" cellspacing="0">
                                        <tr>
                                            <td></td>
                                            <td>Skill</td>
                                            <td>Effort</td>
                                            <td>Confidence</td>
                                        </tr>
                                        <tr *ngFor="let row of rows">
                                            <td>{{row.level | titlecase}}</td>
                                            <td *ngFor="let cell of cells" class="skill-table__cell">
                                                <span class="skill-table__mark has-tooltip has-tooltip--mobilevisible">
                                                    <img *ngIf="row.level == getRowResult(score)[cell.parameter]"
                                                        [src]="emojiReactions[(row.level)]" alt="">
                                                    <span
                                                        class="custom-tooltip custom-tooltip--white custom-tooltip__top white-space-wrap no-border">
                                                        Throughout the course, we were helping you build your Skill, Effort and
                                                        Confidence on
                                                        {{title | titlecase}}.
                                                    </span>
                                                </span>
                                            </td>
                                        </tr>
            
                                    </table>
                                  </div>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
            </ng-container>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!evalData?.isNewEvaluation">
    <div *ngIf="behaviourScore?.length" class="courseDetails" id="courseDetails">
        <div class="container">
            <div class="completeProgressList insightTabList">
                <div class="businessLearner insightLearner">
                    <h5 data-aos="fade-right" data-aos-delay="500" data-aos-duration="500" data-aos-easing="ease-out" class="heading18 mg-b40 mg-tb-b30 text-uppercase darkgrayColor montserrat-semibold">Behaviors Learnt</h5>
                    <div class="learnerBox div-shadow" data-aos="fade-up" data-aos-delay="1000" data-aos-duration="500" data-aos-easing="ease-out">
                        <app-behaviour-table [behaviourScore]="behaviourScore"></app-behaviour-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="assessmentScore?.length" class="courseperformance whitesmoke">
        <div class="container">
            <div class="businessLearner">
                <h5 data-aos="fade-right" data-aos-delay="500" data-aos-duration="500" data-aos-easing="ease-out" class="heading18 mg-b40 mg-tb-b30 text-uppercase darkgrayColor montserrat-semibold">Completed Assessments</h5>

                <ul id="FAQaccordion" class="courseAccordion">
                    <li class="card" *ngFor="let score of assessmentScore;index as i" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-easing="ease-out">
                        <ng-container *ngIf="score?.exerciseResult">
                            <div (click)="showSlick=true" class="card-header" [attr.id]="'FAQheadingOne'+i">
                                <h5 class="mb-0">
                                    <button class="btn btn-link" data-bs-toggle="collapse" [attr.data-bs-target]="'#FAQOne'+i" [attr.aria-expanded]="false" [attr.aria-controls]="'FAQOne'+i">
                      <span
                        class="progressper">{{(score?.exerciseResult?.gainedMarks/score?.exerciseResult?.totalMarks)*100 | number:'1.0-0'}}%
                        &nbsp;
                        <circle-progress [showTitle]="false" [showSubtitle]="false" [showUnits]="false"
                          [percent]="(score?.exerciseResult?.gainedMarks / score?.exerciseResult?.totalMarks) * 100"
                          [radius]="18" [space]="-5" [toFixed]="0" [maxPercent]="100" [unitsFontSize]="10"
                          [unitsColor]="'#e27137'" [outerStrokeWidth]="5" [outerStrokeColor]="'#e27137'"
                          [innerStrokeColor]="'#f9e3d7'" [innerStrokeWidth]="5" [titleColor]="'#e27137'"
                          [titleFontSize]="14" [subtitleFontSize]="6">
                        </circle-progress>
                      </span>
                      <span class="ThinkingText">{{title}} | {{score?.moduleName || ''}}</span>
                      {{score?.title || ''}}<i class="icon-arrow-down"></i>
    
                    </button>
                                </h5>
                            </div>
                            <div *ngIf="showSlick" [attr.id]="'FAQOne'+i" class="collapse" [attr.aria-labelledby]="'FAQheadingOne'+i" data-bs-parent="#FAQaccordion">
                                <div class="card-body">
                                    <a style="padding: 15px 30px 5px; display: inline-block;" href="javascript:void(0)" *ngIf="showBack" (click)="back()" class="topback">
                                        <span class="icon-back"></span> Back
                                    </a>
                                    <app-exercise-insights [evaluationResult]="evalData" [totalPoints]="score?.exerciseResult?.gainedMarks" [totalExPoints]="score?.exerciseResult?.totalMarks" [timeSpent]="score?.exerciseResult?.timeSpent" [exerciseDetails]="{moduleName:score?.moduleName,title:score?.title,assessmentType: score?.exerciseResult?.assessmentType, status: score?.exerciseResult?.status}"
                                        [exerciseRows]="getExerciseRows(score?.id)" [courseId]="id" [fromCoursePage]="true" [exerciseId]="score?.id">
                                    </app-exercise-insights>
                                </div>
                            </div>
                        </ng-container>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div *ngIf="practiceScore?.length" class="coursepracticeBox">
        <div class="container">
            <div class="businessLearner">
                <h5 data-aos="fade-right" data-aos-delay="500" data-aos-duration="500" data-aos-easing="ease-out" class="heading18 mg-b50 mg-tb-b30 text-uppercase darkgrayColor montserrat-semibold">Completed Exercises</h5>
                <div class="insight-strengthbox behavior-practise">
                    <div class="row">
                        <div *ngFor="let item of practiceScore cursor-pointer" class="col-xl-4 col-lg-6 col-md-6 insight-row" data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" data-aos-easing="ease-out">
                            <div class="div-shadow cursor-pointer insight-col" (click)="navigateToPlayer(item.id)">
                                <a href="javascript:void(0)" class="icon-expand fullscreen"></a>
                                <div class="insight-col-progress">
                                    <img src="assets/images/insigt-icon1.png" alt="">
                                </div>
                                <p>{{item.title}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>